import React from "react";

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";

import { useDeleteArea } from "hooks/areas";

const DeleteArea = ({ area, closeModal, isOpen }) => {
  const toast = useToast();

  const [removeArea, { isLoading }] = useDeleteArea(
    {
      onSuccess: () => {
        toast({
          title: "Área removido com sucesso.",
          status: "success",
          duration: 5000,
          isClosable: true,
        }),
          closeModal();
      },
      onError: () => {
        toast({
          title: "Ocorreu um erro.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      },
    }
  );

  return (
    <Modal
      isCentered
      onClose={() => closeModal()}
      isOpen={isOpen}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Deletar Área</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Tem certeza que deseja remover #{area?.name}
        </ModalBody>
        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={() => closeModal()}>
            Cancelar
          </Button>
          <Button
            isLoading={isLoading}
            colorScheme="red"
            onClick={() => removeArea({variables: {id: area?.id}})}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteArea;
